// import React from "react";
// import { Users, Mail, Search, Plus, X, UserMinus } from "lucide-react";
// import { useLocation } from "react-router-dom";
// import MembersPage from "./MembersPage";
// import InvitationsPage from "./InvitationsPage";
// import Cookies from "js-cookie";
// import api from "../chat/api";
// import { toast } from "react-toastify";


// const MyTeam = () => {
//   const location = useLocation();
//   const [activeTab, setActiveTab] = React.useState("members");
//   const [memberCount, setMemberCount] = React.useState(0);
//   const [invitationCount, setInvitationCount] = React.useState(0);
//   const [searchQuery, setSearchQuery] = React.useState("");
//   const [isInviteModalOpen, setIsInviteModalOpen] = React.useState(false);
//   const [organizationId, setOrganizationId] = React.useState(null);
  
//   const [teamMembers, setTeamMembers] = React.useState([]);
//   const [invitations, setInvitations] = React.useState([]);
//   const [loading, setLoading] = React.useState(true);
  
//   const [selectedMembers, setSelectedMembers] = React.useState([]);
//   const [selectedInvitations, setSelectedInvitations] = React.useState([]);
//   const [bulkResending, setBulkResending] = React.useState(false);
//   const [bulkResent, setBulkResent] = React.useState(false);
//   const [bulkCanceling, setBulkCanceling] = React.useState(false);
//   const [bulkCanceled, setBulkCanceled] = React.useState(false);


//   const getInitials = (name) => {
//     if (!name) return "??";
//     const parts = name.trim().split(' ');
//     if (parts.length >= 2) {
//       return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
//     }
//     return name.substring(0, 2).toUpperCase();
//   };


//   const formatDate = (isoDate) => {
//     if (!isoDate) return "_";
//     try {
//       const date = new Date(isoDate);
//       const day = String(date.getDate()).padStart(2, '0');
//       const month = String(date.getMonth() + 1).padStart(2, '0');
//       const year = String(date.getFullYear()).slice(-2);
//       const hours = date.getHours();
//       const displayHours = hours % 12 || 12;
//       const minutes = String(date.getMinutes()).padStart(2, '0');
//       const period = hours >= 12 ? 'pm' : 'am';
      
//       return `${day}/${month}/${year} - ${String(displayHours).padStart(2, '0')}:${minutes}${period}`;
//     } catch (error) {
//       return "_";
//     }
//   };


//   const formatLastLogin = (isoDate) => {
//     if (!isoDate) return "_";
//     try {
//       const date = new Date(isoDate);
//       const now = new Date();
//       const diffMs = now - date;
//       const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      
//       if (diffDays === 0) {
//         const hours = date.getHours() % 12 || 12;
//         const minutes = String(date.getMinutes()).padStart(2, '0');
//         const period = date.getHours() >= 12 ? 'pm' : 'am';
//         return `${String(hours).padStart(2, '0')}:${minutes}${period}`;
//       } else if (diffDays === 1) {
//         return "Yesterday";
//       } else if (diffDays < 7) {
//         return `${diffDays} days ago`;
//       } else {
//         return formatDate(isoDate).split(' - ')[0];
//       }
//     } catch (error) {
//       return "_";
//     }
//   };


//   const formatInviteDate = (isoDate) => {
//     if (!isoDate) return "_";
//     try {
//       const date = new Date(isoDate);
//       const day = String(date.getDate()).padStart(2, '0');
//       const month = String(date.getMonth() + 1).padStart(2, '0');
//       const year = String(date.getFullYear()).slice(-2);
//       return `${day}/${month}/${year}`;
//     } catch (error) {
//       return "_";
//     }
//   };


//   const fetchData = React.useCallback(async () => {
//     setLoading(true);
//     try {
//       const token = Cookies.get("access_token");
//       if (!token) {
//         console.error("No token available");
//         setLoading(false);
//         return;
//       }


//       // Extract Org ID from path
//       const pathSegments = location.pathname.split('/').filter(Boolean);
//       const orgIdFromPath = pathSegments[pathSegments.length - 1];


//       // Fetch specific organization details
//       const orgResponse = await api.get(`/api/v1/org/details/?organization_id=${orgIdFromPath}`);
      
//       if (orgResponse.data) {
//         const orgData = orgResponse.data;
//         setOrganizationId(orgData.id);
        
//         // Fetch invitations for the organization
//         try {
//           const invResponse = await api.get(`/api/v1/org/invites/list/${orgData.id}/`);
          
//           if (invResponse.data && Array.isArray(invResponse.data)) {
//             const pendingInvitations = invResponse.data.filter(inv => inv.status !== "accepted");
//             const formatted = pendingInvitations.map(inv => ({
//               id: inv.id,
//               email: inv.email,
//               role: inv.role,
//               invitationSent: formatInviteDate(inv.created_at),
//               status: inv.status || "pending",
//             }));
//             setInvitations(formatted);
//             setInvitationCount(formatted.length);
//           } else {
//             setInvitations([]);
//             setInvitationCount(0);
//           }
//         } catch (invError) {
//           console.error("Error fetching invitations:", invError);
//           setInvitations([]);
//           setInvitationCount(0);
//         }
        
//         // Process members from the single organization object and sort by joined_at descending
//         const allMembers = orgData.members.map(member => ({
//           id: member.id,
//           user_id: member.user_id,
//           name: member.full_name || member.username,
//           email: member.email,
//           role: member.role,
//           dateJoined: formatDate(member.joined_at),
//           lastLogin: formatLastLogin(member.last_login),
//           initials: getInitials(member.full_name || member.username),
//           isOwner: member.role === "owner",
//           isActive: member.is_active,
//           orgName: orgData.name,
//           orgId: orgData.id,
//           joined_at: member.joined_at  // Keep raw timestamp for sorting
//         })).sort((a, b) => new Date(b.joined_at) - new Date(a.joined_at));
        
//         setTeamMembers(allMembers);
//         setMemberCount(allMembers.length);
//       } else {
//         setTeamMembers([]);
//         setMemberCount(0);
//         setInvitations([]);
//         setInvitationCount(0);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setTeamMembers([]);
//       setMemberCount(0);
//       setInvitations([]);
//       setInvitationCount(0);
//     } finally {
//       setLoading(false);
//     }
//   }, [location.pathname]); 


//   React.useEffect(() => {
//     fetchData();
//   }, [fetchData]);


//   const handleTabClick = (tab) => {
//     setActiveTab(tab);
//     setSearchQuery("");
//     setSelectedMembers([]);
//     setSelectedInvitations([]);
//     setBulkResending(false);
//     setBulkResent(false);
//     setBulkCanceling(false);
//     setBulkCanceled(false);
//   };


//   const handleClearMemberSelection = () => {
//     setSelectedMembers([]);
//   };


//   const handleClearInvitationSelection = () => {
//     setSelectedInvitations([]);
//     setBulkResending(false);
//     setBulkResent(false);
//     setBulkCanceling(false);
//     setBulkCanceled(false);
//   };


//   const handleBulkRemoveAccess = React.useCallback(async () => {
//     const token = Cookies.get("access_token");
//     if (!token) {
//       toast.error("No authentication token available");
//       return;
//     }


//     if (selectedMembers.length === 0) {
//       toast.error("No members selected");
//       return;
//     }


//     try {
//       const membersByOrg = {};
//       selectedMembers.forEach(memberId => {
//         const member = teamMembers.find(m => m.id === memberId);
//         if (member && !member.isOwner) {
//           if (!membersByOrg[member.orgId]) {
//             membersByOrg[member.orgId] = [];
//           }
//           membersByOrg[member.orgId].push(member.user_id);
//         }
//       });


//       const removePromises = Object.entries(membersByOrg).map(([orgId, userIds]) => {
//         return api.post("/api/v1/org/members/remove/", {
//           organization_id: orgId,
//           user_ids: userIds
//         });
//       });


//       await Promise.all(removePromises);


//       toast.success(`${selectedMembers.length} member(s) removed successfully!`);
//       setSelectedMembers([]);
//       setTimeout(() => {
//         fetchData();
//       }, 2000);
//     } catch (error) {
//       console.error("Error removing members:", error);
//       if (error.response?.data?.message) {
//         toast.error(error.response.data.message);
//       } else {
//         toast.error("An error occurred while removing members.");
//       }
//     }
//   }, [selectedMembers, teamMembers, fetchData]);


//   const hasSelectedOwners = React.useMemo(() => {
//     return selectedMembers.some(memberId => {
//       const member = teamMembers.find(m => m.id === memberId);
//       return member?.isOwner;
//     });
//   }, [selectedMembers, teamMembers]);


//   const handleBulkResend = async () => {
//     if (selectedInvitations.length === 0) return;
//     setBulkResending(true);
//     setBulkResent(false);


//     try {
//       await api.post('/api/v1/org/invites/resend/', {
//         invitation_ids: selectedInvitations
//       });


//       setBulkResent(true);
//       setTimeout(() => {
//         setBulkResent(false);
//         setSelectedInvitations([]);
//         fetchData();
//       }, 1500);
//     } catch (error) {
//       console.error("Error resending invitations:", error);
//     } finally {
//       setBulkResending(false);
//     }
//   };


//   const handleBulkCancel = async () => {
//     if (selectedInvitations.length === 0) return;
//     setBulkCanceling(true);
//     setBulkCanceled(false);


//     try {
//       await api.post('/api/v1/org/invites/cancel/', {
//         invitation_ids: selectedInvitations
//       });


//       setBulkCanceled(true);
//       setTimeout(() => {
//         setBulkCanceled(false);
//         setSelectedInvitations([]);
//         fetchData();
//       }, 1500);
//     } catch (error) {
//       console.error("Error canceling invitations:", error);
//     } finally {
//       setBulkCanceling(false);
//     }
//   };


//   const getResendButtonContent = () => {
//     if (bulkResending) return <>Resending...</>;
//     if (bulkResent) return "Resent";
//     return "Resend";
//   };


//   const getCancelButtonContent = () => {
//     if (bulkCanceling) return <>Canceling...</>;
//     if (bulkCanceled) return "Canceled";
//     return "Cancel";
//   };


//   return (
//     <div className=" w-full max-w-6xl mx-auto font-outfit h-full flex flex-col">
//       <div className="mb-6 flex-shrink-0">
//         <h2 className="text-xl font-semibold text-gray-900">Team Members</h2>
//         <p className="text-gray-500 text-[14px] mt-1">
//           Invite team members, manage their roles and access.
//         </p>
//       </div>


//       <div className="bg-white rounded-lg shadow-sm border border-gray-200  flex flex-col overflow-hidden">
//         <div className="p-4 flex items-center justify-between gap-4 border-b border-gray-100 flex-shrink-0">
//           <div className="flex items-center gap-2">
//             <button 
//               onClick={() => handleTabClick("members")}
//               className={`flex items-center gap-2 px-4 py-2 rounded-md text-[14px] font-medium transition-colors ${
//                 activeTab === "members"
                  // ? "bg-[#F200D80D] !text-[#C95EBE]" 
                  // : "!text-gray-600 hover:bg-gray-50"
//               }`}
//             >
//               <Users size={18} />
//               Members ({memberCount})
//             </button>
//             <button 
//               onClick={() => handleTabClick("invitations")}
//               className={`flex items-center gap-2 px-4 py-2 rounded-md text-[14px] font-medium transition-colors ${
//                 activeTab === "invitations"
//                   ? "bg-[#F200D80D] !text-[#C95EBE]" 
//                   : "!text-gray-600 hover:bg-gray-50"
//               }`}
//             >
//               <Mail size={18} />
//               Invitations ({invitationCount})
//             </button>
//           </div>


//           {activeTab === "members" && selectedMembers.length > 0 ? (
//             <div className="flex items-center gap-3">
//               <div className="flex items-center gap-2 px-4 py-2 bg-purple-50 rounded-md">
//                 <span className="text-[14px] font-medium text-purple-700">
//                   {selectedMembers.length} Selected
//                 </span>
//               </div>
//               <button 
//                 onClick={handleBulkRemoveAccess}
//                 disabled={hasSelectedOwners}
//                 className="flex items-center gap-2 px-4 py-2 border border-[#E21919BF] !text-[#E21919BF] rounded-md text-[14px] font-medium hover:!text-white hover:bg-[#E21919BF] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//               >
//                 <UserMinus size={18} />
//                 Remove Access
//               </button>
//               <button 
//                 onClick={handleClearMemberSelection}
//                 className="p-2 hover:bg-gray-100 rounded-md transition-colors"
//                 title="Clear selection"
//               >
//                 <X size={20} className="text-gray-600" />
//               </button>
//             </div>
//           ) : activeTab === "invitations" && selectedInvitations.length > 0 ? (
//             <div className="flex items-center gap-3">
//               <div className="flex items-center gap-2 px-4 py-2 bg-purple-50 rounded-md">
//                 <span className="text-[14px] font-medium text-purple-700">
//                   {selectedInvitations.length} Selected
//                 </span>
//               </div>
//               <button 
//                 onClick={handleBulkResend}
//                 disabled={bulkResending || bulkResent}
//                 className={`flex items-center gap-2 px-4 py-2 rounded-md text-[14px] font-medium transition-colors ${
//                   bulkResent
//                     ? '!bg-[#C95EBE] !text-white cursor-default'
//                     : bulkResending
//                     ? '!bg-[#B14DAA] !text-white cursor-not-allowed opacity-80'
//                     : '!bg-[#C95EBE] !text-white hover:bg-[#B14DAA]'
//                 }`}
//               >
//                 {getResendButtonContent()}
//               </button>
//               <button 
//                 onClick={handleBulkCancel}
//                 disabled={bulkCanceling || bulkCanceled}
//                 className={`flex items-center gap-2 px-4 py-2 border rounded-md text-[14px] font-medium transition-colors ${
//                   bulkCanceled
//                     ? 'border-[#E21919BF] !bg-[#E21919BF] !text-white cursor-default'
//                     : bulkCanceling
//                     ? 'border-[#E21919BF] !bg-[#E21919BF] !text-white cursor-not-allowed opacity-80'
//                     : 'border-[#E21919BF] !text-[#E21919BF] hover:!text-white hover:bg-[#E21919BF]'
//                 }`}
//               >
//                 {getCancelButtonContent()}
//               </button>
//               <button 
//                 onClick={handleClearInvitationSelection}
//                 className="p-2 hover:bg-gray-100 rounded-md transition-colors"
//                 title="Clear selection"
//               >
//                 <X size={20} className="text-gray-600" />
//               </button>
//             </div>
//           ) : (
//             <div className="flex items-center gap-3">
//               <div className="relative w-72">
                // <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600" size={18} />
                // <input
                //   type="text"
                //   placeholder={activeTab === "members" ? "Search by name or email..." : "Search invitations..."}
                //   value={searchQuery}
                //   onChange={(e) => setSearchQuery(e.target.value)}
                //   className="w-full pl-10 pr-4 border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-[#C95EBE] focus:border-transparent box-border"
                //   style={{ height: '40px', fontSize: '14px', lineHeight: '20px' }}
                // />
//               </div>
//               {activeTab === "members" && (
//                 <button 
//                   onClick={() => setIsInviteModalOpen(true)}
//                   className="flex items-center gap-2 !bg-[#C95EBE] !text-white px-4 py-2 rounded-md text-[14px] font-medium hover:bg-[#B14DAA] transition-colors whitespace-nowrap"
//                 >
//                   <Plus size={18} />
//                   Add User
//                 </button>
//               )}
//             </div>
//           )}
//         </div>


//         <div className="flex-1 flex flex-col min-h-0">
//           {activeTab === "members" ? (
//             <MembersPage 
//               teamMembers={teamMembers}
//               loading={loading}
//               searchQuery={searchQuery}
//               isInviteModalOpen={isInviteModalOpen}
//               setIsInviteModalOpen={setIsInviteModalOpen}
//               organizationId={organizationId}
//               onRefresh={fetchData}
//               selectedMembers={selectedMembers}
//               setSelectedMembers={setSelectedMembers}
//             />
//           ) : (
//             <InvitationsPage 
//               invitations={invitations}
//               loading={loading}
//               searchQuery={searchQuery}
//               organizationId={organizationId}
//               onRefresh={fetchData}
//               selectedInvitations={selectedInvitations}
//               setSelectedInvitations={setSelectedInvitations}
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };


// export default MyTeam;
import React from "react";
import { Users, Mail, Search, Plus, X, UserMinus } from "lucide-react";
import MembersPage from "./MembersPage";
import InvitationsPage from "./InvitationsPage";
import ReassignProjectsModal from "./ReassignProjectsModal";
import RemoveMemberModal from "./RemoveMemberModal";
import {
  groupByOrg,
  selectRemovableMembers,
  strandedMessage,
  summarizeRemoval,
} from "./bulkRemoval";
import Cookies from "js-cookie";
import api, { getCurrentUser } from "../chat/api";
import toast from "react-hot-toast";
import { fetchRfpSubscription } from "../../services/rfpBillingApi";
import UpsellTooltip from "../../components/UpsellTooltip";
import { PageHeader } from "./settings/ui";

// Invites only exist once a plan is active (§6.2 of the billing PRD) — a
// trial workspace has zero invite capability, no matter how many seats it
// technically has, and the backend's TeamRequiresPaidPlan enforces exactly
// this set of states server-side (rfp/billing/entitlements.py INVITE_STATES).
const INVITE_ENABLED_STATES = new Set(["active", "renewal_due"]);

const MyTeam = () => {
  const [activeTab, setActiveTab] = React.useState("members");
  const [memberCount, setMemberCount] = React.useState(0);
  const [invitationCount, setInvitationCount] = React.useState(0);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [isInviteModalOpen, setIsInviteModalOpen] = React.useState(false);
  const [organizationId, setOrganizationId] = React.useState(null);
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [rfpAccess, setRfpAccess] = React.useState(null);

  const [teamMembers, setTeamMembers] = React.useState([]);
  const [invitations, setInvitations] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  
  const [selectedMembers, setSelectedMembers] = React.useState([]);
  const [selectedInvitations, setSelectedInvitations] = React.useState([]);
  const [bulkResending, setBulkResending] = React.useState(false);
  const [bulkResent, setBulkResent] = React.useState(false);
  const [bulkCanceling, setBulkCanceling] = React.useState(false);
  const [bulkCanceled, setBulkCanceled] = React.useState(false);

  // ── Bulk removal + reassigning what the leavers own ─────────────────────────
  // Rename / archive / delete / share are owner-only, so removing someone who
  // owns projects freezes them for everyone. Same flow as the per-row removal in
  // MembersPage: if the selection owns anything, ask who takes over first.
  const [bulkRemoving, setBulkRemoving] = React.useState(false);
  const [reassignFor, setReassignFor] = React.useState(null); // member[] being removed
  const [reassignOrgId, setReassignOrgId] = React.useState(null);
  const [reassignError, setReassignError] = React.useState("");
  // Exactly one dialog per removal: this plain confirm when nobody owns
  // anything, the reassignment modal when somebody does.
  const [confirmFor, setConfirmFor] = React.useState(null); // member[]
  const [confirmUnknown, setConfirmUnknown] = React.useState(false);
  // user_id -> how many projects they own in this workspace, prefetched for the
  // whole roster in one aggregate. Which removal dialog to raise depends on this
  // answer, and asking at click time put a visible stall between pressing
  // "Remove Access" and anything happening — up to a second for a heavy owner.
  // `null` means "not loaded yet", which the handlers fall back on.
  const [ownedCounts, setOwnedCounts] = React.useState(null);

  const getInitials = (name) => {
    if (!name) return "??";
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const formatDate = (isoDate) => {
    if (!isoDate) return "_";
    try {
      const date = new Date(isoDate);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear()).slice(-2);
      const hours = date.getHours();
      const displayHours = hours % 12 || 12;
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const period = hours >= 12 ? 'pm' : 'am';

      return `${month}/${day}/${year} - ${String(displayHours).padStart(2, '0')}:${minutes}${period}`;
    } catch (error) {
      return "_";
    }
  };

  const formatLastLogin = (isoDate) => {
    if (!isoDate) return "_";
    try {
      const date = new Date(isoDate);
      const now = new Date();
      const diffMs = now - date;
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      
      if (diffDays === 0) {
        const hours = date.getHours() % 12 || 12;
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const period = date.getHours() >= 12 ? 'pm' : 'am';
        return `${String(hours).padStart(2, '0')}:${minutes}${period}`;
      } else if (diffDays === 1) {
        return "Yesterday";
      } else if (diffDays < 7) {
        return `${diffDays} days ago`;
      } else {
        return formatDate(isoDate).split(' - ')[0];
      }
    } catch (error) {
      return "_";
    }
  };

  const formatInviteDate = (isoDate) => {
    if (!isoDate) return "_";
    try {
      const date = new Date(isoDate);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear()).slice(-2);
      return `${month}/${day}/${year}`;
    } catch (error) {
      return "_";
    }
  };

  const fetchData = React.useCallback(async () => {
    setLoading(true);
    try {
      const token = Cookies.get("access_token");
      if (!token) {
        console.error("No token available");
        setLoading(false);
        return;
      }

      // Sync with the global sidebar workspace switcher via selected_org_id.
      const orgId = Cookies.get("selected_org_id");
      if (!orgId) {
        setIsAdmin(false);
        setTeamMembers([]);
        setMemberCount(0);
        setInvitations([]);
        setInvitationCount(0);
        setLoading(false);
        return;
      }

      const orgResponse = await api.get(`/api/v1/org/details/?organization_id=${orgId}`);
      
      if (orgResponse.data) {
        const orgData = orgResponse.data;
        setOrganizationId(orgData.id);

        // Determine whether the current user is an admin of THIS organization by
        // locating their own membership in the returned members list. Only admins
        // can access invitations (the invites endpoint 403s for everyone else).
        const me = getCurrentUser();
        const myMembership = (orgData.members || []).find(m =>
          (me?.user_id != null && m.user_id === me.user_id) ||
          (me?.email && m.email?.toLowerCase() === me.email.toLowerCase())
        );
        const admin = myMembership?.role === "admin";
        setIsAdmin(admin);

        // Only fetch invitations for admins — avoids the 403 entirely for members.
        if (admin) {
          try {
            const invResponse = await api.get(`/api/v1/org/invites/list/${orgData.id}/`);
            if (invResponse.data && Array.isArray(invResponse.data)) {
              const pendingInvitations = invResponse.data.filter(inv => inv.status !== "accepted");
              const formatted = pendingInvitations.map(inv => ({
                id: inv.id,
                email: inv.email,
                role: inv.role,
                invitationSent: formatInviteDate(inv.created_at),
                status: inv.status || "pending",
              }));
              setInvitations(formatted);
              setInvitationCount(formatted.length);
            } else {
              setInvitations([]);
              setInvitationCount(0);
            }
          } catch (invError) {
            console.error("Error fetching invitations:", invError);
            setInvitations([]);
            setInvitationCount(0);
            toast.error("Couldn't load invitations.");
          }
        } else {
          setInvitations([]);
          setInvitationCount(0);
        }

        const allMembers = orgData.members.map(member => ({
          id: member.id,
          user_id: member.user_id,
          name: member.full_name || member.username,
          email: member.email,
          // "member" is deprecated — only reviewer/editor/admin remain, so show it as editor.
          role: member.role === "member" ? "editor" : member.role,
          dateJoined: formatDate(member.joined_at),
          lastLogin: formatLastLogin(member.last_login),
          initials: getInitials(member.full_name || member.username),
          isOwner: member.role === "owner",
          isActive: member.is_active,
          orgName: orgData.name,
          orgId: orgData.id,
          joined_at: member.joined_at
        })).sort((a, b) => new Date(b.joined_at) - new Date(a.joined_at));
        
        setTeamMembers(allMembers);
        setMemberCount(allMembers.length);
      } else {
        setIsAdmin(false);
        setTeamMembers([]);
        setMemberCount(0);
        setInvitations([]);
        setInvitationCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsAdmin(false);
      setTeamMembers([]);
      setMemberCount(0);
      setInvitations([]);
      setInvitationCount(0);
      toast.error("Couldn't load this organization's details.");
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    fetchData();
    // Refetch when the user switches workspace from the global sidebar. Any
    // pending reassignment belongs to the workspace we just left, so drop it -
    // its projects and candidates are about to be replaced.
    const onWorkspaceChange = () => {
      setSelectedMembers([]);
      setReassignFor(null);
      setReassignOrgId(null);
      setReassignError("");
      setConfirmFor(null);
      setConfirmUnknown(false);
      fetchData();
    };
    window.addEventListener("workspace-changed", onWorkspaceChange);
    return () => window.removeEventListener("workspace-changed", onWorkspaceChange);
  }, [fetchData]);

  // Drives the invite lock below — refetched on workspace switch same as the
  // member list, so switching into a trial workspace re-locks immediately.
  React.useEffect(() => {
    let cancelled = false;
    const loadAccess = () => {
      fetchRfpSubscription()
        .then((data) => {
          if (!cancelled) setRfpAccess(data);
        })
        .catch(() => {
          if (!cancelled) setRfpAccess(null);
        });
    };
    loadAccess();
    window.addEventListener("workspace-changed", loadAccess);
    return () => {
      cancelled = true;
      window.removeEventListener("workspace-changed", loadAccess);
    };
  }, []);

  const canInvite = rfpAccess ? INVITE_ENABLED_STATES.has(rfpAccess.state) : true;
  const inviteLockedTitle = "Subscribe to invite your team";
  const inviteLockedSubtitle =
    rfpAccess?.state === "trialing"
      ? "Trials are solo — any paid plan unlocks teammates."
      : "Pick a plan to add teammates to this workspace.";

  // Refreshed alongside the member list. A failure here is not worth surfacing -
  // the click-time lookup is still there as a fallback.
  React.useEffect(() => {
    const ids = (teamMembers || []).map((m) => m.user_id).filter(Boolean);
    if (!isAdmin || !organizationId || ids.length === 0) {
      setOwnedCounts(null);
      return undefined;
    }
    let cancelled = false;
    api
      .get(
        `/api/v1/org/members/owned-projects/?organization_id=${encodeURIComponent(
          organizationId
        )}&user_ids=${encodeURIComponent(ids.join(","))}&counts_only=1`
      )
      .then((res) => {
        if (!cancelled) setOwnedCounts(res.data?.counts || {});
      })
      .catch(() => {
        if (!cancelled) setOwnedCounts(null);
      });
    return () => {
      cancelled = true;
    };
  }, [teamMembers, organizationId, isAdmin]);

  const handleTabClick = (tab) => {
    if (bulkRemoving) return;
    setActiveTab(tab);
    setSearchQuery("");
    setSelectedMembers([]);
    setReassignFor(null);
    setReassignOrgId(null);
    setReassignError("");
    setSelectedInvitations([]);
    setBulkResending(false);
    setBulkResent(false);
    setBulkCanceling(false);
    setBulkCanceled(false);
  };

  const handleClearMemberSelection = () => {
    if (bulkRemoving) return;
    setSelectedMembers([]);
  };

  const handleClearInvitationSelection = () => {
    setSelectedInvitations([]);
    setBulkResending(false);
    setBulkResent(false);
    setBulkCanceling(false);
    setBulkCanceled(false);
  };

  const removableSelected = React.useMemo(
    () =>
      selectRemovableMembers(selectedMembers, teamMembers, getCurrentUser()?.user_id),
    [selectedMembers, teamMembers]
  );

  const postBulkRemoval = React.useCallback(async (members, reassignments) => {
    const groups = groupByOrg(members);
    const settled = await Promise.allSettled(
      groups.map(([orgId, userIds]) =>
        api.post("/api/v1/org/members/remove/", {
          organization_id: orgId,
          user_ids: userIds,
          ...(reassignments && Object.keys(reassignments).length
            ? { reassignments }
            : {}),
        })
      )
    );

    settled.forEach((result) => {
      if (result.status === "rejected") {
        console.error("Error removing members:", result.reason);
      }
    });

    return summarizeRemoval(groups, settled);
  }, []);

  const reportBulkRemoval = React.useCallback(
    (outcome) => {
      if (outcome.removed > 0) {
        toast.success(
          outcome.reassigned
            ? `${outcome.removed} member(s) removed. ${outcome.reassigned} project(s) reassigned.`
            : `${outcome.removed} member(s) removed successfully!`
        );
      }
      // A project left behind by a failed handover is stuck until someone
      // transfers it, so say so rather than letting the success toast imply
      // everything went through.
      const stranded = strandedMessage(outcome);
      if (stranded) toast.error(stranded);
      if (outcome.failed > 0) {
        toast.error(
          outcome.error || `Couldn't remove ${outcome.failed} member(s).`
        );
      }
      // On a total failure nothing changed, so leave the selection alone and the
      // retry stays one click away.
      if (outcome.removed > 0) {
        setSelectedMembers([]);
        setTimeout(() => {
          fetchData();
        }, 2000);
      }
    },
    [fetchData]
  );

  const handleBulkRemoveAccess = React.useCallback(async () => {
    if (bulkRemoving || reassignFor || confirmFor) return;

    const token = Cookies.get("access_token");
    if (!token) {
      toast.error("No authentication token available");
      return;
    }

    if (removableSelected.length === 0) {
      toast.error(
        selectedMembers.length
          ? "None of the selected members can be removed."
          : "No members selected"
      );
      return;
    }

    setBulkRemoving(true);
    try {
      // Both the lookup and the modal are scoped to a single workspace. MyTeam
      // only ever shows one at a time, but if a selection somehow spans several
      // we remove without reassigning rather than hand projects to the wrong
      // workspace — they stay reachable through per-project transfer.
      const orgIds = Array.from(new Set(removableSelected.map((m) => m.orgId)));
      let unknown = true; // a selection spanning workspaces can't be checked in one call

      if (orgIds.length === 1) {
        let ownedCount = 0;
        unknown = false;

        const fromCache =
          ownedCounts &&
          removableSelected.every((m) => ownedCounts[String(m.user_id)] !== undefined);

        if (fromCache) {
          ownedCount = removableSelected.reduce(
            (sum, m) => sum + (ownedCounts[String(m.user_id)] || 0),
            0
          );
        } else {
          try {
            const res = await api.get(
              `/api/v1/org/members/owned-projects/?organization_id=${encodeURIComponent(
                orgIds[0]
              )}&user_ids=${encodeURIComponent(
                removableSelected.map((m) => m.user_id).join(",")
              )}`
            );
            ownedCount = (res.data?.projects || []).length;
          } catch {
            unknown = true; // never block a removal because this lookup failed
          }
        }

        if (ownedCount > 0) {
          setReassignError("");
          setReassignOrgId(orgIds[0]);
          setReassignFor(removableSelected);
          return;
        }
      }

      setConfirmUnknown(unknown);
      setConfirmFor(removableSelected);
    } finally {
      setBulkRemoving(false);
    }
  }, [bulkRemoving, reassignFor, confirmFor, removableSelected, selectedMembers, ownedCounts]);

  const closeConfirm = React.useCallback(() => {
    setConfirmFor(null);
    setConfirmUnknown(false);
  }, []);

  const closeReassignModal = React.useCallback(() => {
    setReassignFor(null);
    setReassignOrgId(null);
    setReassignError("");
  }, []);

  const hasSelectedOwners = React.useMemo(() => {
    return selectedMembers.some(memberId => {
      const member = teamMembers.find(m => m.id === memberId);
      return member?.isOwner;
    });
  }, [selectedMembers, teamMembers]);

  const handleBulkResend = async () => {
    if (selectedInvitations.length === 0) return;
    setBulkResending(true);
    setBulkResent(false);

    try {
      await api.post('/api/v1/org/invites/resend/', {
        invitation_ids: selectedInvitations
      });

      setBulkResent(true);
      setTimeout(() => {
        setBulkResent(false);
        setSelectedInvitations([]);
        fetchData();
      }, 1500);
    } catch (error) {
      console.error("Error resending invitations:", error);
    } finally {
      setBulkResending(false);
    }
  };

  const handleBulkCancel = async () => {
    if (selectedInvitations.length === 0) return;
    setBulkCanceling(true);
    setBulkCanceled(false);

    try {
      await api.post('/api/v1/org/invites/cancel/', {
        invitation_ids: selectedInvitations
      });

      setBulkCanceled(true);
      setTimeout(() => {
        setBulkCanceled(false);
        setSelectedInvitations([]);
        fetchData();
      }, 1500);
    } catch (error) {
      console.error("Error canceling invitations:", error);
    } finally {
      setBulkCanceling(false);
    }
  };

  const getResendButtonContent = () => {
    if (bulkResending) return <>Resending...</>;
    if (bulkResent) return "Resent";
    return "Resend";
  };

  const getCancelButtonContent = () => {
    if (bulkCanceling) return <>Revoking...</>;
    if (bulkCanceled) return "Revoked";
    return "Revoke";
  };

  return (
    // Changed: Removed max-w-6xl so it takes full width of the parent flex container
    <div className="w-full font-outfit h-full flex flex-col">
      <div className="flex-shrink-0">
        <PageHeader
          title="Members"
          description="Invite team members, manage their roles and access."
        />
      </div>

      <div className="bg-white rounded-lg border border-black/10 flex flex-col flex-1 min-h-0 overflow-hidden">
        <div className="p-4 flex items-center justify-between gap-4 border-b border-black/10 flex-shrink-0 flex-wrap">
          <div className="flex items-center gap-2">
            <button 
              onClick={() => handleTabClick("members")}
              className={`flex items-center gap-2 px-4 py-2 rounded-md text-[14px] font-medium transition-colors ${
                activeTab === "members"
                ? "bg-[#F200D80D] !text-[#C95EBE]" 
                : "!text-gray-600 hover:bg-gray-50"
              }`}
            >
              <Users size={18} />
              Members ({memberCount})
            </button>
            <button
              onClick={() => handleTabClick("invitations")}
              disabled={!isAdmin}
              title={!isAdmin ? "Only admins can manage invitations" : undefined}
              className={`flex items-center gap-2 px-4 py-2 rounded-md text-[14px] font-medium transition-colors ${
                !isAdmin
                ? "!text-gray-400 cursor-not-allowed opacity-50"
                : activeTab === "invitations"
                ? "bg-[#F200D80D] !text-[#C95EBE]"
                : "!text-gray-600 hover:bg-gray-50"
              }`}
            >
              <Mail size={18} />
              Invitations ({invitationCount})
            </button>
          </div>

          {activeTab === "members" && selectedMembers.length > 0 ? (
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-2 px-4 py-2 bg-purple-50 rounded-md">
                <span className="text-[14px] font-medium text-purple-700">
                  {selectedMembers.length} Selected
                </span>
              </div>
              <button
                onClick={handleBulkRemoveAccess}
                disabled={hasSelectedOwners || bulkRemoving || !!reassignFor || !!confirmFor}
                className="flex items-center gap-2 px-4 py-2 border border-red-500 text-red-500 rounded-md text-[14px] font-medium hover:text-white hover:bg-red-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <UserMinus size={18} />
                {bulkRemoving ? "Removing…" : "Remove Access"}
              </button>
              <button
                onClick={handleClearMemberSelection}
                disabled={bulkRemoving}
                className="p-2 hover:bg-gray-100 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                title="Clear selection"
              >
                <X size={20} className="text-gray-600" />
              </button>
            </div>
          ) : activeTab === "invitations" && selectedInvitations.length > 0 ? (
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-2 px-4 py-2 bg-purple-50 rounded-md">
                <span className="text-[14px] font-medium text-purple-700">
                  {selectedInvitations.length} Selected
                </span>
              </div>
              <button 
                onClick={handleBulkResend}
                disabled={bulkResending || bulkResent}
                className={`flex items-center gap-2 px-4 py-2 rounded-md text-[14px] font-medium transition-colors ${
                  bulkResent
                    ? 'bg-[#C95EBE] text-white cursor-default'
                    : bulkResending
                    ? 'bg-[#B14DAA] text-white cursor-not-allowed opacity-80'
                    : 'bg-[#C95EBE] text-white hover:bg-[#B14DAA]'
                }`}
              >
                {getResendButtonContent()}
              </button>
              <button 
                onClick={handleBulkCancel}
                disabled={bulkCanceling || bulkCanceled}
                className={`flex items-center gap-2 px-4 py-2 border rounded-md text-[14px] font-medium transition-colors ${
                  bulkCanceled
                    ? 'border-red-500 bg-red-500 text-white cursor-default'
                    : bulkCanceling
                    ? 'border-red-500 bg-red-500 text-white cursor-not-allowed opacity-80'
                    : 'border-red-500 text-red-500 hover:text-white hover:bg-red-500'
                }`}
              >
                {getCancelButtonContent()}
              </button>
              <button 
                onClick={handleClearInvitationSelection}
                className="p-2 hover:bg-gray-100 rounded-md transition-colors"
                title="Clear selection"
              >
                <X size={20} className="text-gray-600" />
              </button>
            </div>
          ) : (
            <div className="flex items-center gap-3 w-full sm:w-auto">
              <div className="relative flex-1 sm:w-64">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600" size={18} />
                <input
                  type="text"
                  placeholder={activeTab === "members" ? "Search by name or email..." : "Search invitations..."}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-10 pr-4 border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-[#C95EBE] focus:border-transparent box-border"
                  style={{ height: '35px', fontSize: '14px', lineHeight: '20px' }}
                />
              </div>
              {activeTab === "members" && isAdmin && (
                canInvite ? (
                  <button
                    onClick={() => setIsInviteModalOpen(true)}
                    className="flex items-center gap-2 bg-[#C95EBE] text-white px-4 py-2 rounded-md text-[13px] font-medium hover:bg-[#B14DAA] transition-colors whitespace-nowrap"
                  >
                    <Plus size={18} />
                    Add User
                  </button>
                ) : (
                  <UpsellTooltip title={inviteLockedTitle} subtitle={inviteLockedSubtitle}>
                    <button
                      disabled
                      className="flex items-center gap-2 bg-gray-100 !text-gray-400 px-4 py-2 rounded-md text-[13px] font-medium cursor-not-allowed whitespace-nowrap"
                    >
                      <Plus size={18} />
                      Add User
                    </button>
                  </UpsellTooltip>
                )
              )}
            </div>
          )}
        </div>

        {/* Changed: flex-1 min-h-0 allows child components to take up remaining height properly */}
        <div className="flex-1 min-h-0 relative">
          {activeTab === "members" ? (
            <MembersPage
              teamMembers={teamMembers}
              loading={loading}
              searchQuery={searchQuery}
              isInviteModalOpen={isInviteModalOpen}
              setIsInviteModalOpen={setIsInviteModalOpen}
              organizationId={organizationId}
              onRefresh={fetchData}
              selectedMembers={selectedMembers}
              setSelectedMembers={setSelectedMembers}
              isAdmin={isAdmin}
              bulkRemovalActive={bulkRemoving || !!reassignFor || !!confirmFor}
              ownedCounts={ownedCounts}
            />
          ) : (
            <InvitationsPage 
              invitations={invitations}
              loading={loading}
              searchQuery={searchQuery}
              organizationId={organizationId}
              onRefresh={fetchData}
              selectedInvitations={selectedInvitations}
              setSelectedInvitations={setSelectedInvitations}
            />
          )}
        </div>
      </div>

      <ReassignProjectsModal
        isOpen={!!reassignFor}
        organizationId={reassignOrgId}
        departingMembers={reassignFor || []}
        candidates={(teamMembers || [])
          .filter((m) => m.isActive !== false && m.user_id)
          .map((m) => ({ user_id: m.user_id, full_name: m.name, email: m.email }))}
        removing={bulkRemoving}
        error={reassignError}
        onClose={() => {
          if (bulkRemoving) return;
          closeReassignModal();
        }}
        onConfirm={async (assignments) => {
          const cleaned = Object.fromEntries(
            Object.entries(assignments || {}).filter(([, v]) => v)
          );
          const departing = reassignFor || [];
          if (!departing.length) {
            closeReassignModal();
            return;
          }
          setBulkRemoving(true);
          setReassignError("");
          try {
            const outcome = await postBulkRemoval(departing, cleaned);
            if (outcome.removed === 0) {
              // Nothing happened — stay open so the assignments aren't lost.
              setReassignError(
                outcome.error || "Failed to remove the selected members."
              );
              return;
            }
            closeReassignModal();
            reportBulkRemoval(outcome);
          } finally {
            setBulkRemoving(false);
          }
        }}
      />

      <RemoveMemberModal
        isOpen={!!confirmFor}
        members={confirmFor || []}
        ownershipUnknown={confirmUnknown}
        onClose={closeConfirm}
        onConfirm={async (departing) => {
          setBulkRemoving(true);
          try {
            const outcome = await postBulkRemoval(departing);
            if (outcome.removed === 0) {
              // Let the modal's own catch close it; the toast carries the reason.
              reportBulkRemoval(outcome);
              throw new Error(outcome.error || "removal failed");
            }
            reportBulkRemoval(outcome);
          } finally {
            setBulkRemoving(false);
          }
        }}
      />
    </div>
  );
};

export default MyTeam;
